import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, Transition as _Transition, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/logo_orange.svg'
import _imports_1 from '@/assets/logo_gray.svg'


const _hoisted_1 = { class: "nav nav-main" }
const _hoisted_2 = { class: "nav-time" }
const _hoisted_3 = ["href"]
const _hoisted_4 = { class: "nav nav-header" }
const _hoisted_5 = { class: "nav-logo-container" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "logo",
  alt: ""
}, null, -1)
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Меню ")
const _hoisted_8 = { class: "price" }
const _hoisted_9 = { class: "nav nav-footer" }
const _hoisted_10 = { class: "nav-logo-container" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "logo",
  alt: ""
}, null, -1)
const _hoisted_12 = { class: "nav-time" }
const _hoisted_13 = { class: "nav-footer-contacts" }
const _hoisted_14 = ["href"]
const _hoisted_15 = { class: "nav-footer-social" }
const _hoisted_16 = ["href"]
const _hoisted_17 = { class: "show-min" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NavItems = _resolveComponent("NavItems")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_CardPage = _resolveComponent("CardPage")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("header", {
      class: _normalizeClass({ 'section-hidden': _ctx.showMealCardPage })
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("section", null, [
          _createElementVNode("nav", null, [
            _createVNode(_component_NavItems, { menuItems: _ctx.mainMenuItems }, null, 8, ["menuItems"])
          ]),
          _createElementVNode("div", _hoisted_2, " Пн-Вс с " + _toDisplayString(_ctx.workTime.start.hour) + ":" + _toDisplayString(_ctx.workTime.start.minute) + " до " + _toDisplayString(_ctx.workTime.finish.hour) + ":" + _toDisplayString(_ctx.workTime.finish.minute), 1),
          _createElementVNode("a", {
            href: 'tel:' + _ctx.phone.link,
            class: "nav-phone"
          }, _toDisplayString(_ctx.phone.title), 9, _hoisted_3)
        ])
      ]),
      _createElementVNode("section", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_router_link, { to: "/" }, {
            default: _withCtx(() => [
              _hoisted_6
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", {
          class: "nav-mobile",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showMobileMenu = !_ctx.showMobileMenu))
        }, [
          _hoisted_7,
          _createElementVNode("div", {
            class: _normalizeClass(["nav-mobile-burger", { opened: _ctx.showMobileMenu }])
          }, null, 2)
        ]),
        _createElementVNode("nav", {
          class: _normalizeClass({ opened: _ctx.showMobileMenu })
        }, [
          _createVNode(_component_NavItems, { menuItems: _ctx.sectionsToMenuItems }, null, 8, ["menuItems"])
        ], 2),
        _createVNode(_component_router_link, {
          to: { name: 'Basket' },
          class: "basket",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showMobileMenu = false))
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.basketCost), 1)
          ]),
          _: 1
        })
      ])
    ], 2),
    _createElementVNode("main", {
      class: _normalizeClass({ 'section-hidden': _ctx.showMealCardPage })
    }, [
      _createVNode(_component_router_view, null, {
        default: _withCtx(({ Component }) => [
          _createVNode(_Transition, { name: "component-fade" }, {
            default: _withCtx(() => [
              (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
            ]),
            _: 2
          }, 1024)
        ]),
        _: 1
      })
    ], 2),
    _createElementVNode("footer", {
      class: _normalizeClass({ 'section-hidden': _ctx.showMealCardPage })
    }, [
      _createElementVNode("section", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_router_link, { to: "/" }, {
            default: _withCtx(() => [
              _hoisted_11
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_12, " Пн-Вс с " + _toDisplayString(_ctx.workTime.start.hour) + ":" + _toDisplayString(_ctx.workTime.start.minute) + " до " + _toDisplayString(_ctx.workTime.finish.hour) + ":" + _toDisplayString(_ctx.workTime.finish.minute), 1)
        ]),
        _createElementVNode("nav", null, [
          _createVNode(_component_NavItems, { menuItems: _ctx.mainMenuItems }, null, 8, ["menuItems"]),
          _createElementVNode("ul", null, [
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, { to: { name: 'Oferta' } }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.info.oferta.title), 1)
                ]),
                _: 1
              })
            ]),
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, { to: { name: 'Policy' } }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.info.policy.title), 1)
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", null, [
            _createElementVNode("a", {
              href: 'tel:' + _ctx.phone.link,
              class: "nav-phone"
            }, _toDisplayString(_ctx.phone.title), 9, _hoisted_14)
          ]),
          _createElementVNode("div", _hoisted_15, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.social, (item, ind) => {
              return (_openBlock(), _createElementBlock("span", { key: ind }, [
                _createElementVNode("a", {
                  href: item?.link,
                  class: "instagram",
                  target: "_blank"
                }, null, 8, _hoisted_16)
              ]))
            }), 128))
          ]),
          _createElementVNode("span", null, _toDisplayString(_ctx.info.protect.title), 1)
        ])
      ]),
      _createElementVNode("section", _hoisted_17, [
        _createVNode(_component_router_link, { to: { name: 'Oferta' } }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.info.oferta.title), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, { to: { name: 'Policy' } }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.info.policy.title), 1)
          ]),
          _: 1
        }),
        _createElementVNode("span", null, _toDisplayString(_ctx.info.protect.title), 1)
      ])
    ], 2),
    _createVNode(_Transition, { name: "component-fade" }, {
      default: _withCtx(() => [
        (_ctx.showMealCardPage)
          ? (_openBlock(), _createBlock(_component_CardPage, { key: 0 }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}